export default "__VITE_ASSET__C$22Smiq__"